module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.mode == 'login') ? _c('div', {
    key: "login",
    staticClass: "login padding--large text--center",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.doLogin()
      }
    }
  }, [_c('div', {
    staticClass: "form login__form"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/logo-light.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "inputEmail",
    staticClass: "login__username",
    attrs: {
      "placeholder": "Email Address",
      "type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "login__password",
    attrs: {
      "placeholder": "Password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.loginActive) ? _c('div', [_c('p', [_vm._v("Loading")])]) : _c('div', [_c('input', {
    staticClass: "login__submit",
    attrs: {
      "type": "submit",
      "value": "Log In"
    },
    on: {
      "click": function($event) {
        _vm.doLogin()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "login__forgotten-password",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.mode = 'forgot-password'
      }
    }
  }, [_vm._v("Forgotten Password?")])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.mode == 'forgot-password') ? _c('div', {
    key: "forgot",
    staticClass: "login padding--large text--center",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.doResetPassword()
      }
    }
  }, [_c('div', {
    staticClass: "form login__form"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/logo-light.svg"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.passwordResetSent) ? _c('div', {
    key: "notsent"
  }, [_c('p', {
    staticClass: "message text--center"
  }, [_vm._v("Enter your email address to be sent a password reset link")]), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailReset),
      expression: "emailReset"
    }],
    ref: "inputEmailReset",
    staticClass: "login__username reset",
    attrs: {
      "placeholder": "Email Address",
      "type": "email"
    },
    domProps: {
      "value": (_vm.emailReset)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailReset = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "login__submit",
    attrs: {
      "type": "submit",
      "value": "Go"
    },
    on: {
      "click": function($event) {
        _vm.doResetPassword()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "login__forgotten-password",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.mode = 'login'
      }
    }
  }, [_vm._v("Cancel")])])]) : _c('div', {
    key: "sent"
  }, [_c('p', {
    staticClass: "message text--center"
  }, [_vm._v("An email has been sent to '" + _vm._s(_vm.emailReset) + "'. Please follow the instructions contained within to reset your password...")]), _vm._v(" "), _c('a', {
    staticClass: "login__forgotten-password",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Go back to Login")])])])], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07408986","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Login/Login.vue
// module id = 531
// module chunks = 1